import {createAction, props} from "@ngrx/store";

export const ADD_MARKETS = '[Markets API] Markets added';
export const ADD_MARKET = '[Markets API] Market added';

export const addMarkets = createAction(
  ADD_MARKETS,
  props<{ markets: Set<string> }>()
);

export const addMarket = createAction(
  ADD_MARKET,
  props<{ market: string }>()
);
